import { FC, useContext } from 'react';
import { Loader, Skeleton, Stack } from '@mantine/core';
import PanePaper from '../PanePaper';
import BookitupAddIcon from '../../Atoms/BookitupAddIcon';
import { ViolationContext } from '../../Service/Context/ViolationContext';
import { LicenceS } from '../../Service/LicenceS';
import EmptyText from '../../Atoms/EmptyText';
import { useEventNotes } from '../../Service/hooks/useEventNotes';
import NoteItem from './NoteItem';

const NoteList: FC<{ asideBar: boolean }> = ({ asideBar }) => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const {
    loading,
    addingNote,
    eventNotes,
    customerNotes,
    add,
    length,
    updateEventNote,
    removeEventNote,
    updateContactNote,
    removeContactNote,
  } = useEventNotes();

  const getAddIcon = () => {
    if (addingNote) return <Loader size="xs" />;
    if (length > 0) {
      return (
        <BookitupAddIcon onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.MULTIPLE_EVENT_NOTES, add)} />
      );
    }
    return <BookitupAddIcon onClick={add} />;
  };

  return (
    <PanePaper
      withShadow={asideBar}
      withoutBorder={asideBar}
      title="common.notes"
      tooltip="help.event.notes.pane"
      rightSection={getAddIcon()}
    >
      {!loading && !addingNote && length === 0 && <EmptyText />}
      {(loading || addingNote) && <Skeleton height={100} width="100%" />}
      {length > 0 && (
        <Stack>
          {eventNotes.map((note) => (
            <NoteItem key={note.id} note={note} updateHandler={updateEventNote} deleteHandler={removeEventNote} />
          ))}
          {customerNotes.map((note) => (
            <NoteItem key={note.id} note={note} updateHandler={updateContactNote} deleteHandler={removeContactNote} />
          ))}
        </Stack>
      )}
    </PanePaper>
  );
};

export default NoteList;
